var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgImportant = function SvgImportant(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M131.014,355.825A1,1,0,0,0,132,357a.867.867,0,0,0,.893-.535,1,1,0,0,1,1.9.627A2.813,2.813,0,0,1,132,359a3,3,0,0,1-2.959-3.5,3.082,3.082,0,0,1,3.066-2.5,1.021,1.021,0,0,0,1.078-.9l.522-5.22a1.685,1.685,0,0,0-.434-1.317,1.759,1.759,0,0,0-2.546,0,1.685,1.685,0,0,0-.434,1.317l.423,4.232a1,1,0,1,1-1.99.2l-.423-4.232a3.715,3.715,0,1,1,7.394,0l-.522,5.22a2.991,2.991,0,0,1-2.985,2.7A1.118,1.118,0,0,0,131.014,355.825Z",
    transform: "translate(-120 -339)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImportant, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/important.093b33c7.svg";
export { ForwardRef as ReactComponent };